import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BATTLES_UNAVAILABLE = (
    <FormattedMessage
        id='schedule.battles_unavailable'
        defaultMessage='Сражения не проводятся'
    />
)

export const ALL_BATTLES_NEXT_PRIMETIME = (time) => (
    <FormattedMessage
        id='battle_rooms.empty_list.all_battles_schedule_item'
        defaultMessage='Ближайшие сражения: {time}'
        values={{ time }}
    />
)



// WEBPACK FOOTER //
// ./containers/Schedule/components/NoBattlesMessage/translations.js